import React, { useEffect } from 'react';

import { noop } from 'lodash';
import { useNavigate } from 'react-router-dom';

import { useAuth } from '~/context/AuthContext';
import { useMainTopBar } from '~/context/MainTopBarContext';
import Button from '~/core/atoms/Buttons/Button';
import CliveAvatar from '~/core/iconComponents/special/CliveAvatar';

const Home: React.FC = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { setMainTopBarProps } = useMainTopBar();

  const HELP_BUTTONS: {
    key: string;
    text: string;
    onClick: () => void;
    hidden?: boolean;
  }[] = [
    {
      key: 'open-claim',
      text: 'Open Existing Claim',
      onClick: noop,
      hidden: true,
    },
    {
      key: 'create-claim',
      text: 'Create New Claim',
      onClick: () => navigate('/fnol'),
    },
  ];

  useEffect(() => {
    setMainTopBarProps({
      claimId: undefined,
      claimInfo: undefined,
      breadcrumbItem: undefined,
      lineOfBusiness: undefined,
    });
  }, [setMainTopBarProps]);

  return (
    <div className="flex w-full flex-1 flex-col items-center justify-center pb-80">
      <div className="flex flex-col items-center justify-center">
        <div className="shadow-inner-avatar mb-20 flex h-80 w-80 items-center justify-center rounded-3xl bg-transparent">
          <CliveAvatar className="scale-150 rounded-full" size="xl" />
        </div>
        <div>
          <div className="flex justify-center">
            <div className="mb-12 flex flex-col items-center justify-center gap-20 text-4xl">
              <span className="text-grey-600">Hello {user?.name}!</span>
            </div>
          </div>
          <div className="flex flex-col gap-12 text-center">
            <h1 className="mb-40 font-light tracking-tight text-balance text-slate-800">
              Smarter claims, seamless processing - Clive’s got you covered!
            </h1>
            <p className="my-12 font-bold text-pretty text-blue-500">What I can help you with?</p>
            <div className="flex items-center justify-center gap-x-16">
              {HELP_BUTTONS.filter((button) => !button.hidden).map((button) => (
                <Button
                  key={button.key}
                  variant="secondary"
                  className="rounded-xl border border-blue-200 bg-blue-300/10 px-20 py-8 text-slate-900 transition-colors duration-300 ease-in-out hover:bg-pink-100/20"
                  onClick={button.onClick}
                >
                  {button.text}
                </Button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
